// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonIcon_wrapper__lNyo9","iconWrapper":"ButtonIcon_iconWrapper__x76-G"};